import { render, staticRenderFns } from "./TypeDetailPage.vue?vue&type=template&id=11811eed&"
import script from "./TypeDetailPage.vue?vue&type=script&lang=js&"
export * from "./TypeDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports